import {
  type DrawerProps,
  Box,
  Drawer,
  List,
  ListItemButton,
  styled,
  Text,
} from '@shared/components';
import { generatePath } from 'react-router-dom';

import { MENU_DRAWER_WIDTH_LARGE, MENU_DRAWER_WIDTH_SMALL } from '../../constants';
import { useSidebar } from '../../providers';
import { NavMenuItem } from '../nav-menu-item';
import { SidebarBottomMenu } from '../sidebar-bottom-menu';
import { SidebarLogo } from '../sidebar-logo';

export const BaseSidebar = styled(Drawer, {
  name: 'Sidebar',
  slot: 'Root',
  overridesResolver: (_, styles) => [styles['root']],
  shouldForwardProp: (prop) => prop !== 'minified',
})<DrawerProps & { minified: boolean }>(({ theme, minified }) => ({
  display: 'none',
  [theme.breakpoints.up('md')]: {
    display: 'block',
  },

  '& .MuiPaper-root': {
    position: 'relative',
    width: minified ? MENU_DRAWER_WIDTH_SMALL : MENU_DRAWER_WIDTH_LARGE,
    transition: 'all 100ms ease-in-out',
  },
}));

export default function Sidebar() {
  const { isOpen, appMenu } = useSidebar();
  const mappedAppMenu = appMenu.map((menu) => ({
    ...menu,
    items: menu.items?.map((item) => ({
      ...item,
      link: generatePath(item?.link ?? ''),
    })),
  }));

  return (
    <BaseSidebar variant='permanent' open minified={!isOpen}>
      <SidebarLogo minified={!isOpen} />
      <List>
        {mappedAppMenu.map((menu) => (
          <Box key={menu.section ?? menu.items?.[0]?.label}>
            {menu.section ? (
              <ListItemButton disabled className='section'>
                <Text>{menu.section}</Text>
              </ListItemButton>
            ) : null}
            {menu.items.map((item) => (
              <NavMenuItem key={item.label as string} {...item} minified={!isOpen} />
            ))}
          </Box>
        ))}
      </List>
      <SidebarBottomMenu />
    </BaseSidebar>
  );
}
